import React from 'react';
import {
  SegmentProvider as SharedSegmentProvider,
  type SegmentProviderProps,
  useSegment,
} from '@hellodarwin/app-core/lib/providers/segment-provider';
import { CLIENT_APP_PAGE_PROPERTIES } from '../analytics/client-analytics-constants';

export const DEFAULT_CLIENT_APP_SEGMENT_WRITE_KEY =
  'mdkntFTs2kgcdXdQstiDz15EY3kQDPbY';

export type ClientSegmentProviderProps = Omit<
  SegmentProviderProps,
  'initialPageProperties'
>;
export { useSegment };

export const SegmentProvider: React.FC<ClientSegmentProviderProps> = ({
  writeKey = DEFAULT_CLIENT_APP_SEGMENT_WRITE_KEY,
  ...props
}) => (
  <SharedSegmentProvider
    {...props}
    writeKey={writeKey}
    initialPageProperties={CLIENT_APP_PAGE_PROPERTIES}
  />
);

export default SegmentProvider;
